import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import PortfolioInfo from './components/PortfolioInfo';

// The owner studio and the standalone gallery are separate chunks, so the
// landing page bundle carries neither. /studio is reached only by typing the
// URL. /gallery is linked from the nav and from the Drones section.
const OwnerStudio = lazy(() => import('./components/OwnerStudio'));
const GalleryPage = lazy(() => import('./components/GalleryPage'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route path="home" />
          <Route path="about" />
          <Route path="services" />
          <Route path="experience" />
          <Route path="portfolio">
            <Route path=":portfolioId" element={<PortfolioInfo />} />
          </Route>
          <Route path="testimonials" />
        </Route>
        <Route
          path="/studio"
          element={
            <Suspense fallback={null}>
              <OwnerStudio />
            </Suspense>
          }
        />
        <Route
          path="/gallery"
          element={
            <Suspense fallback={null}>
              <GalleryPage />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
